import React from 'react';
import { Outlet } from 'react-router-dom';
import { AnalyticsCategoryProvider, Categories } from '@app/analytics';
import { PageTitle } from 'components';
import { useTranslation } from 'react-i18next';

export const ForgottenPassword = () => {
  const { t } = useTranslation();
  return (
    <AnalyticsCategoryProvider category={Categories.FORGOT_PASSWORD}>
      <React.Fragment>
        <PageTitle title={t('forgottenPassword.metaTitle')} />
        <Outlet />
      </React.Fragment>
    </AnalyticsCategoryProvider>
  );
};
